import React from "react";
import {
  AbsoluteFill,
  Img,
  interpolate,
  spring,
  staticFile,
  useCurrentFrame,
  useVideoConfig,
  Easing,
} from "remotion";

export const FreshSwissEditorial: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  // 1. Editorial Calm Spring Animations
  const lineEntrance = interpolate(frame, [10, 35], [100, 0], {
    easing: Easing.bezier(0.16, 1, 0.3, 1),
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const photoReveal = spring({
    frame: frame - 15,
    fps,
    config: { damping: 24, stiffness: 100 },
  });

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "#F6F3EB",
        color: "#1C1917",
        fontFamily: "'Playfair Display', 'Georgia', 'Times New Roman', serif",
        padding: "80px 60px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
      }}
    >
      {/* Editorial Grid Lines */}
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 60,
          width: 1,
          backgroundColor: "rgba(28,25,23,0.08)",
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          right: 60,
          width: 1,
          backgroundColor: "rgba(28,25,23,0.08)",
        }}
      />

      {/* 1. Header: Magazine Header */}
      <div
        style={{
          borderBottom: "2px solid #1C1917",
          paddingBottom: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "baseline",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
          zIndex: 20,
        }}
      >
        <div style={{ fontSize: 26, fontWeight: 900, letterSpacing: "0.2em", textTransform: "uppercase" }}>
          KYU REVIEW
        </div>
        <div style={{ fontSize: 16, fontWeight: 500, letterSpacing: "0.1em", color: "#78716C" }}>
          ISSUE 04 • AUTUMN 2026
        </div>
        <div style={{ fontSize: 16, fontWeight: 700, letterSpacing: "0.1em", color: "#C2410C" }}>
          TOP-UP RESMI
        </div>
      </div>

      {/* 2. Headline: High-Contrast Serif Display */}
      <div style={{ marginTop: 40, zIndex: 20 }}>
        <div style={{ overflow: "hidden" }}>
          <h1
            style={{
              fontSize: 84,
              lineHeight: 1.05,
              fontWeight: 400,
              fontStyle: "italic",
              margin: 0,
              letterSpacing: "-0.02em",
              transform: `translateY(${lineEntrance}%)`,
            }}
          >
            Kemewahan Dalam
          </h1>
        </div>
        <div style={{ overflow: "hidden" }}>
          <h1
            style={{
              fontSize: 92,
              lineHeight: 1.0,
              fontWeight: 700,
              margin: 0,
              letterSpacing: "-0.03em",
              color: "#C2410C",
              transform: `translateY(${lineEntrance}%)`,
            }}
          >
            Kecepatan 0.8 Detik.
          </h1>
        </div>
      </div>

      {/* 3. Centerpiece: Editorial Framed Portrait Window */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: 800,
          backgroundColor: "#EDE8DF",
          border: "1px solid #D6D3D1",
          borderRadius: 16,
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
          transform: `scale(${0.92 + photoReveal * 0.08})`,
          opacity: photoReveal,
          zIndex: 10,
        }}
      >
        <Img
          src={staticFile("assets_library/dynamic_renders/mlbb_fanny_blade_of_kibou.png")}
          style={{
            height: "105%",
            width: "100%",
            objectFit: "cover",
            objectPosition: "center top",
            filter: "contrast(1.05) saturate(1.1)",
          }}
        />

        {/* Floating Minimalist Stamp */}
        <div
          style={{
            position: "absolute",
            top: 24,
            left: 24,
            backgroundColor: "#1C1917",
            color: "#F6F3EB",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: "0.15em",
            padding: "8px 16px",
            borderRadius: 6,
          }}
        >
          CURATED ESSENTIALS
        </div>
      </div>

      {/* 4. Bottom Editorial Spec Sheet & Price */}
      <div
        style={{
          borderTop: "1px solid rgba(28,25,23,0.15)",
          paddingTop: 30,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif",
          zIndex: 20,
        }}
      >
        <div>
          <div style={{ fontSize: 16, fontWeight: 700, color: "#78716C", letterSpacing: "0.1em" }}>
            OFFICIAL MOONTON PASS
          </div>
          <div
            style={{
              fontSize: 56,
              fontWeight: 800,
              fontFamily: "'Playfair Display', serif",
              lineHeight: 1.1,
              marginTop: 4,
            }}
          >
            Rp 27.500
          </div>
        </div>

        <div style={{ textAlign: "right" }}>
          <div style={{ fontSize: 14, color: "#78716C", marginBottom: 6 }}>
            INSTANT DELIVERY VIA USER ID
          </div>
          <div
            style={{
              display: "inline-block",
              backgroundColor: "#1C1917",
              color: "#F6F3EB",
              padding: "16px 32px",
              borderRadius: 8,
              fontSize: 18,
              fontWeight: 700,
              letterSpacing: "0.08em",
            }}
          >
            ORDER SEKARANG
          </div>
        </div>
      </div>
    </AbsoluteFill>
  );
};
